module.exports = __webpack_public_path__ + "assets/img/Travel_006.6617ad8b-ps.jpg";